import { KeenSliderPlugin } from 'keen-slider/react'

export const SliderWheelController: KeenSliderPlugin = (slider) => {
    let touchTimeout: NodeJS.Timeout
    let position: { x: number; y: number }
    let wheelActive: boolean

    function dispatch(e: WheelEvent, name: string) {
        position.x -= e.deltaX
        position.y -= e.deltaY
        slider.container.dispatchEvent(
            new CustomEvent(name, {
                detail: {
                    x: position.x,
                    y: position.y,
                },
            })
        )
    }

    function wheelStart(e: WheelEvent) {
        position = {
            x: e.pageX,
            y: e.pageY,
        }
        dispatch(e, 'ksDragStart')
    }

    function wheel(e: WheelEvent) {
        dispatch(e, 'ksDrag')
    }

    function wheelEnd(e: WheelEvent) {
        dispatch(e, 'ksDragEnd')
    }

    function eventWheel(e: WheelEvent) {
        e.preventDefault()
        if (!wheelActive) {
            wheelStart(e)
            wheelActive = true
        }
        wheel(e)
        clearTimeout(touchTimeout)
        touchTimeout = setTimeout(() => {
            wheelActive = false
            wheelEnd(e)
        }, 50)
    }

    slider.on('created', () => {
        slider.container.addEventListener('wheel', eventWheel, {
            passive: false,
        })
    })
}
